import { Box, Link, Paper, Stack, Typography } from '@mui/material'
import { LoadingButton } from '@mui/lab'
import type { FC } from 'react'
import type { WelcomeProps } from './types'

export const WelcomeView: FC<WelcomeProps> = (props) => {
    const { handleStartWizard, objectModifyLink, objectInitLoading } = props

    return (
        <Box className='max-w-2xl mx-auto mt-14'>
            <Paper className='p-6 rounded-md shadow-lg'>
                <Box
                    py={7}
                    px={2}
                    textAlign='center'
                >
                    <Typography
                        variant='h4'
                        pb={1}
                        margin={'center'}
                    >
                        VÝBĚR SLUŽBY
                    </Typography>
                    <Typography
                        pb={1}
                        margin={'center'}
                        paddingTop={0}
                        fontSize={'0.875rem'}
                    >
                        Vítáme Vás v online průvodci pro výběr bezpečnostní
                        služby pro následující období. S výběrem služby Vám
                        pomůže náš virtuální bezpečnostní expert, který Vám
                        doporučí službu na základě Vašich odpovědí.
                    </Typography>
                    <Box>
                        <Typography
                            px={2}
                            pb={4}
                            margin={'center'}
                            fontSize={'0.875rem'}
                        >
                            Jakmile proběhne ověření Vašich údajů, budete moci
                            pokračovat v průvodci.
                        </Typography>
                        <Stack
                            className='text-center'
                            alignItems='center'
                            spacing={3}
                        >
                            <LoadingButton
                                variant='contained'
                                loading={objectInitLoading}
                                loadingIndicator='Načítáme...'
                                color='primary'
                                className='shadow-none'
                                size='large'
                                onClick={handleStartWizard}
                            >
                                Pokračovat v průvodci
                            </LoadingButton>
                            {!objectInitLoading && (
                                <Link
                                    href={objectModifyLink}
                                    underline='always'
                                    className='normal-case text-pantone-black-70 text-xs md:text-[1rem]'
                                    color='inherit'
                                >
                                    {
                                        'Mám zájem o úpravu nastavení mého objektu'
                                    }
                                </Link>
                            )}
                        </Stack>
                    </Box>
                </Box>
            </Paper>
        </Box>
    )
}
